import { Layout as ReactAdminLayout} from 'react-admin';
import Menu from '~/components/Menu';

const Layout = (props) => <ReactAdminLayout {...props} menu={Menu} />;

export default Layout;